import * as React from "react";
import Drawer from "@mui/material/Drawer";
import CriticalImg from "../../assets/critical-image.svg";
import LowImage from '../../assets/low-img.svg';
import MediumImage from '../../assets/medium-img.svg';
import HighImage from '../../assets/high-img.svg';
import redirectIcon from "../../assets/redirect-icon.svg";

import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

function CveSideBar({
  handleClose,
  open,
  cveData
}
) {
  const seveirtyIssue = () => {
    let image;
    const severity = cveData?.Severity
    if (severity === 'low')
      image = LowImage
    if (severity === 'medium')
      image = MediumImage
    if (severity === 'critical')
      image = CriticalImg
    else if (severity === 'high')
      image = HighImage;  // You need to define this image or handle it
    return (<span>
      {image ? <img src={image} alt='icon'></img> : "-"}
    </span>)
  }
  const DrawerList = (
    <Box
      sx={{ width: 800 }}
      className="drawer-padding"
      role="presentation"
    >
      <TableContainer sx={{ p: 1 }} className="Drawer-popup-rightside">
        <Table
          sx={{ minWidth: 100 }}
          aria-label="simple table"
          className="table-attacks"
        >
          <TableHead sx={{ borderRadius: "10px 10px 0 0" }}>
            <TableRow>
              <TableCell>CVE</TableCell>
              <TableCell>Score</TableCell>
              <TableCell>Severity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{cveData?.CVE}</TableCell>
              <TableCell>{cveData?.Score}</TableCell>
              <TableCell>{seveirtyIssue()}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <div className="cve-detail">
        <div className="cve-header-common">
          <div>Technology</div>
        </div>
        <p>{cveData?.Technology}</p>
      </div>
      <div className="flexi-Cwe">
        <div className="cve-detail">
          <div className="cve-header-common">
            <div>CPE</div>
          </div>
          <p>{cveData?.CPE}</p>
        </div>
        <div className="cve-detail">
          <div className="cve-header-common">
            <div>CWE</div>
          </div>
          <p>
            {cveData?.CWE}
          </p>
        </div>
      </div>
      <div className="cve-detail">
        <div className="cve-header-common">
          <div>Description</div>
        </div>
        <p>{cveData?.Description}</p>
      </div>
      <div className="cve-detail">
        <div className="cve-header-common">
          <div>Remediation</div>
        </div>
        <p>{cveData?.Remediation}</p>
      </div>
      <div className="cve-detail">
        <div className="cve-header-common">
          <div>Affected URLs</div>
        </div>
        {cveData.URL && cveData.URL.map((url , index) => (
          <p key={url} style={{ display: 'flex' }}>
            #{index + 1}.{"    "}
            <a 

              href={
                url?.startsWith("http://") || url?.startsWith("https://")
                  ? url
                  : `http://${url}`
              }
              target="_blank"
              rel="noopener noreferrer" style={{ marginLeft: '30px', display: 'flex', color: "white", flexDirection: 'row', flexWrap: 'wrap', marginRight: '2%' }}
            >
              {url}
              <img src={redirectIcon} alt='icon'></img>
            </a></p>
        ))}


      </div>
      <div className="cve-detail">
        <div className="cve-header-common">
          <div>Advisory Links </div>
        </div>
        {cveData?.Reference?.map((link, index) => (
          <p key={index} style={{ display: 'flex' }}>
            #{index + 1}.{"    "}
            <a href={link.startsWith("http://") || link.startsWith("https://")
              ? link : `http://${link}`
            }
              target="_blank"
              rel="noopener noreferrer" style={{ marginLeft: '30px', display: 'flex', color: "white", flexDirection: 'row', flexWrap: 'wrap', marginRight: '2%' }}>
              {link}
              <img src={redirectIcon} alt='icon'></img>
            </a>
          </p>
        ))}
      </div>
    </Box>
  );

  return (
    <div>
      <Drawer anchor="right" open={open} onClose={handleClose}
        ModalProps={{
          "disablebackdropclick": "true",
          "disableEscapeKeyDown": "true",
        }}>
        {DrawerList}
      </Drawer>
    </div>
  );
}

export default CveSideBar;
